import React, { useState } from 'react'
import { Dropdown, Button as AButton, Descriptions, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { toast } from 'react-toastify'

import Backend from '../../../api/Backend'

import List from '../../../components/List'
import Drawer from '../../../components/Drawer'
import ContentItem from '../../../components/ContentItem'
import HspProviderSelect from '../../../components/HspProviderSelect'

import Utils from '../../../components/Utils'
import Symptom from '../../../components/Symptom'
import ContentTypeSelect from '../../../components/ContentTypeSelect'
import { AppointmentScheduler } from '../../AppointmentScheduler'

import { LangContext } from '../../../components/Translation'
import { useGlobalContext } from '../../../components/AppContext'

import translations from './translations'

import './index.css'

export default function SymptomAlarms({
	className = '',
	patientId,
	clinicId,
	key,
	patientPseudoName,
	interventionGroup,
	onInterventionTriggered = () => {},
	data
}) {
	const actions = {
		EMAIL_SEND: 'EMAIL_SEND',
		PHONE_CALL: `PHONE_CALL`,
		PERSONAL_CONTACT: `PERSONAL_CONTACT`,
		RECOMMEND_CONTENT: 'RECOMMEND_CONTENT',
		RECOMMEND_HSP: 'RECOMMEND_HSP',
		ALARM_DOC_TYPE_NO_CONTACT: 'ALARM_DOC_TYPE_NO_CONTACT',
		ALARM_DOC_TYPE_ATTEMPT_NOT_REACHED: 'ALARM_DOC_TYPE_ATTEMPT_NOT_REACHED',
		ALARM_DOC_TYPE_CONTACT_NO_FURTHER_ACTION: 'ALARM_DOC_TYPE_CONTACT_NO_FURTHER_ACTION',
		ALARM_DOC_TYPE_CONTACT_INTERVENTION: 'ALARM_DOC_TYPE_CONTACT_INTERVENTION',
		ALARM_DOC_TYPE_COVERED_BY_OTHER_ALARM: 'ALARM_DOC_TYPE_COVERED_BY_OTHER_ALARM',
		ALARM_DOC_ACTION_CONTENT_RECOMMENDED: 'ALARM_DOC_ACTION_CONTENT_RECOMMENDED',
		ALARM_DOC_ACTION_HSP_RECOMMENDED: 'ALARM_DOC_ACTION_HSP_RECOMMENDED',
	}

	const subcategoryA = {
		ALARM_DOC_SUB_A1_LOW_GRADE_NO_ACTION: 'ALARM_DOC_SUB_A1_LOW_GRADE_NO_ACTION',
		ALARM_DOC_SUB_A2_AE_TREATED_NO_NEW: 'ALARM_DOC_SUB_A2_AE_TREATED_NO_NEW',
		ALARM_DOC_SUB_A3_IN_CLINIC_HANDLED: 'ALARM_DOC_SUB_A3_IN_CLINIC_HANDLED',
		ALARM_DOC_SUB_A4_PLANNED_APPOINTMENT: 'ALARM_DOC_SUB_A4_PLANNED_APPOINTMENT',
		ALARM_DOC_SUB_A5_OTHER: 'ALARM_DOC_SUB_A5_OTHER'
	}

	const subcategoryB = {
		ALARM_DOC_SUB_B1_ATTEMPT_NOT_REACHED_RETRY_PLANNED: 'ALARM_DOC_SUB_B1_ATTEMPT_NOT_REACHED_RETRY_PLANNED',
		ALARM_DOC_SUB_B2_ATTEMPT_NOT_REACHED_AWAITING_REPLY: 'ALARM_DOC_SUB_B2_ATTEMPT_NOT_REACHED_AWAITING_REPLY',
		ALARM_DOC_SUB_B3_OTHER: 'ALARM_DOC_SUB_B3_OTHER'
	}

	const subcategoryC = {
		ALARM_DOC_SUB_C1_COUNSELLING_NO_ACTION: 'ALARM_DOC_SUB_C1_COUNSELLING_NO_ACTION',
		ALARM_DOC_SUB_C2_LOW_GRADE_NO_ACTION: 'ALARM_DOC_SUB_C2_LOW_GRADE_NO_ACTION',
		ALARM_DOC_SUB_C3_AE_TREATED_NO_NEW: 'ALARM_DOC_SUB_C3_AE_TREATED_NO_NEW',
		ALARM_DOC_SUB_C4_IN_CLINIC_HANDLED: 'ALARM_DOC_SUB_C4_IN_CLINIC_HANDLED',
		ALARM_DOC_SUB_C5_PLANNED_APPOINTMENT: 'ALARM_DOC_SUB_C5_PLANNED_APPOINTMENT',
		ALARM_DOC_SUB_C6_OTHER: 'ALARM_DOC_SUB_C6_OTHER'
	}

    const subcategoryD = {
        ALARM_DOC_SUB_D1_CARETEAM_PHONE_COUNSELLING: 'ALARM_DOC_SUB_D1_CARETEAM_PHONE_COUNSELLING',
        ALARM_DOC_SUB_D2_TAGESKLINIK_MEDICAL_CLARIFICATION: 'ALARM_DOC_SUB_D2_TAGESKLINIK_MEDICAL_CLARIFICATION',
        ALARM_DOC_SUB_D3_REFERRED_EXTERNAL_PHYSICIAN: 'ALARM_DOC_SUB_D3_REFERRED_EXTERNAL_PHYSICIAN',
        ALARM_DOC_SUB_D4_TAGESKLINIK_NURSING_CONSULT: 'ALARM_DOC_SUB_D4_TAGESKLINIK_NURSING_CONSULT',
        ALARM_DOC_SUB_D5_PSYCHO_ONCO_CONSULTATION: 'ALARM_DOC_SUB_D5_PSYCHO_ONCO_CONSULTATION',
        ALARM_DOC_SUB_D6_ER_EMERGENCY_REFERRAL: 'ALARM_DOC_SUB_D6_ER_EMERGENCY_REFERRAL',
        ALARM_DOC_SUB_D7_DIGITAL_CONTENT_RECOMMENDED: 'ALARM_DOC_SUB_D7_DIGITAL_CONTENT_RECOMMENDED',
        ALARM_DOC_SUB_D8_DIGITAL_SERVICE_RECOMMENDED: 'ALARM_DOC_SUB_D8_DIGITAL_SERVICE_RECOMMENDED',
        ALARM_DOC_SUB_D9_OTHER: 'ALARM_DOC_SUB_D9_OTHER'
    }

    const backend = new Backend()
	const utils = new Utils()
	const lang = React.useContext(LangContext)(translations)

	const { globals, isEnavProject } = useGlobalContext()


	const [action, setAction] = useState()
	const [content, setContent] = useState([])
	const [selectedHSPs, setSelectedHSPs] = useState()

	const handleActionsClick = e => {
		const action = e.key
		if (action === actions.ALARM_DOC_TYPE_COVERED_BY_OTHER_ALARM) {
			performAction(action)
		} else {
			setAction(action)
		}
	}

	const handleSubcategoryClick = e => {
		performAction(e.key)
	}


	console.log(data)

	const performAction = action => {
		const interventionForSymptomId = data[0] ? data[0].resource?.id : null
		const interventionForSymptomString = data[0] ? data[0].resource?.symptom : null
		if ((action === actions.RECOMMEND_CONTENT || action === actions.ALARM_DOC_ACTION_CONTENT_RECOMMENDED) && content && content.length > 0) {
			const body = JSON.stringify({
				data: content.map((item) => {
					return { contentId: item?.key, contentType: item?.type?.id }
				}),
				interventionForSymptomId,
				interventionForSymptomString
			})
			backend.patientContent({
				patientId,
				body,
				type: backend.type.CREATE,
				cb: () => {
					setContent([])
					const message = lang('intervention-triggered')
					toast.info(message, { toastId: message })
				}
			})
		} else if (action === actions.RECOMMEND_HSP || action === actions.ALARM_DOC_ACTION_HSP_RECOMMENDED) {
			const body = JSON.stringify({
				data: selectedHSPs,
				interventionForSymptomId,
				interventionForSymptomString
			})
			backend.healthProvider({
				patientId,
				body,
				type: backend.type.CREATE,
				cb: () => {
					setSelectedHSPs([])
					const message = lang('intervention-triggered')
					toast.info(message, { toastId: message })
				}
			})
		} else {
			const body = JSON.stringify({
				type: action,
				interventionForSymptomId,
				interventionForSymptomString
			})
			backend.patientIntervention({
				patientId,
				body,
				type: backend.type.CREATE,
				cb: () => {
					const message = lang('intervention-triggered')
					toast.info(message, { toastId: message })
				}
			})
		}
		resetAction()
		onInterventionTriggered()
	}

	const resetAction = () => {
		setAction(undefined)
	}

	const handleContentChange = values => {
		setContent(values)
	}

	const handleHspAssignment = values => {
		setSelectedHSPs(values)
	}


	const actionMenu = (
		<Menu onClick={handleActionsClick}>
			{/*	<Menu.Item key={actions.SCHEDULE_APPOINTMENT}>{ lang(actions.SCHEDULE_APPOINTMENT.toLowerCase()) }</Menu.Item> */}
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_TYPE_NO_CONTACT}>
				{lang(actions.ALARM_DOC_TYPE_NO_CONTACT.toLowerCase())}
			</Menu.Item>
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_TYPE_ATTEMPT_NOT_REACHED}>
				{lang(actions.ALARM_DOC_TYPE_ATTEMPT_NOT_REACHED.toLowerCase())}
			</Menu.Item>
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_TYPE_CONTACT_NO_FURTHER_ACTION}>
				{lang(actions.ALARM_DOC_TYPE_CONTACT_NO_FURTHER_ACTION.toLowerCase())}
			</Menu.Item>
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_TYPE_CONTACT_INTERVENTION}>
				{lang(actions.ALARM_DOC_TYPE_CONTACT_INTERVENTION.toLowerCase())}
			</Menu.Item>
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_TYPE_COVERED_BY_OTHER_ALARM}>
				{lang(actions.ALARM_DOC_TYPE_COVERED_BY_OTHER_ALARM.toLowerCase())}
			</Menu.Item>
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_ACTION_CONTENT_RECOMMENDED}>
				{lang(actions.ALARM_DOC_ACTION_CONTENT_RECOMMENDED.toLowerCase())}
			</Menu.Item>
			<Menu.Item disabled={isEnavProject() &&  !interventionGroup} key={actions.ALARM_DOC_ACTION_HSP_RECOMMENDED}>
				{lang(actions.ALARM_DOC_ACTION_HSP_RECOMMENDED.toLowerCase())}
			</Menu.Item>
		</Menu>
	)

	const subcategoryMenu = (
		<Menu onClick={handleSubcategoryClick}>
			{action && action === actions.ALARM_DOC_TYPE_NO_CONTACT && Object.keys(subcategoryA).map(key => (
				<Menu.Item key={key}>{lang(key.toLowerCase())}</Menu.Item>
			))}
			{action && action === actions.ALARM_DOC_TYPE_ATTEMPT_NOT_REACHED && Object.keys(subcategoryB).map(key => (
				<Menu.Item key={key}>{lang(key.toLowerCase())}</Menu.Item>
			))}
			{action && action === actions.ALARM_DOC_TYPE_CONTACT_NO_FURTHER_ACTION && Object.keys(subcategoryC).map(key => (
				<Menu.Item key={key}>{lang(key.toLowerCase())}</Menu.Item>
			))}
			{action && action === actions.ALARM_DOC_TYPE_CONTACT_INTERVENTION && Object.keys(subcategoryD).map(key => (
				<Menu.Item key={key}>{lang(key.toLowerCase())}</Menu.Item>
			))}
		</Menu>
	)

	const renderInterventions = symptoms => {
        const renderType = intervention => {
			if (intervention.type === 'CONTENT') {
				return (
					<React.Fragment key={intervention}>
						<Descriptions.Item>{lang('content')}</Descriptions.Item>
						<Descriptions.Item>
							<ContentItem value={[intervention]} />
						</Descriptions.Item>
						<Descriptions.Item>{utils.toDate({ dateString: intervention.createdAt })}</Descriptions.Item>
						<Descriptions.Item>{intervention.initiator}</Descriptions.Item>
					</React.Fragment>
				)
			} else if (intervention.type === 'HSP') {
				intervention.title = intervention.resource.hspTitle

				return (
					<React.Fragment key={intervention}>
						<Descriptions.Item>{lang('hsp')}</Descriptions.Item>
						<Descriptions.Item>
							<ContentItem value={[intervention]} />
						</Descriptions.Item>
						<Descriptions.Item>{utils.toDate({ dateString: intervention.createdAt })}</Descriptions.Item>
						<Descriptions.Item>{intervention.initiator}</Descriptions.Item>
					</React.Fragment>
				)
			} else {
				return (
					<React.Fragment key={intervention}>
						<Descriptions.Item span={2}>{lang(intervention.type?.toLowerCase())}</Descriptions.Item>
						<Descriptions.Item>{utils.toDate({ dateString: intervention.createdAt })}</Descriptions.Item>
						<Descriptions.Item>{intervention.initiator}</Descriptions.Item>
					</React.Fragment>
				)
			}
        }


        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ marginBottom: '16px' }}>{lang('interventions')}</h3>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', marginBottom: '16px' }}>
                    <div style={{ width: '250px' }}>
                        <Dropdown overlay={actionMenu} style={{ margin: `auto` }}>
                            <AButton style={{ width: '100%', padding: '4px 11px' }}>
                                <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {action ? lang(action.toLowerCase()) : lang('trigger-intervention')}
                                    </span>
                                    <DownOutlined />
                                </span>
                            </AButton>
                        </Dropdown>
                    </div>
                    <div style={{ width: '250px' }}>
                        {(action && (action === actions.ALARM_DOC_TYPE_NO_CONTACT || action === actions.ALARM_DOC_TYPE_ATTEMPT_NOT_REACHED || action === actions.ALARM_DOC_TYPE_CONTACT_NO_FURTHER_ACTION || action === actions.ALARM_DOC_TYPE_CONTACT_INTERVENTION)) 
                            && <Dropdown overlay={subcategoryMenu} style={{ margin: `auto` }}>
                                    <AButton style={{ width: '100%', padding: '4px 11px' }}>
                                        <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {lang('choose-subcategory')}
                                            </span>
                                            <DownOutlined />
                                        </span>
                                    </AButton>
                                </Dropdown>
                        }
                    </div>
                </div>
                <Descriptions column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }}>
                    {symptoms.length > 0 ? symptoms[0].interventions.map(renderType) : ''}
                </Descriptions>
            </div>
        )
    }

    const symptoms = Array.isArray(data)
		? data.map(d => {
				return {
					title: <Symptom symptom={d.resource.symptom} severity={d.resource.severity} score={d.resource.score} />,
					content: <></>,
					description: <div>{utils.toDate({ dateString: d.created_at })}</div>,
					id: d.id
				}
		  })
		: []

	let actionElement = null
	if (action === actions.SCHEDULE_APPOINTMENT) {
		actionElement = <AppointmentScheduler className="mt20" data={{ patientId }} />
	} else if (action === actions.RECOMMEND_CONTENT || action === actions.ALARM_DOC_ACTION_CONTENT_RECOMMENDED) {
		actionElement = (
			<ContentTypeSelect
				key='interventionList'
				placeholder={lang('select')}
				value={content}
				clinicId={clinicId}
				group={['ALL', 'INTERVENTION']}
				onChange={handleContentChange}
			/>
		)
	} else if (action === actions.RECOMMEND_HSP || action === actions.ALARM_DOC_ACTION_HSP_RECOMMENDED) {
		actionElement = <HspProviderSelect clinicId={globals.selectedCenter} placeholder={lang('select')} value={selectedHSPs} onChange={handleHspAssignment} />
	}

	return (
		<div className={`${className}`}>
			<div className="col-md-12 col-xl-12">
				<Drawer
					key={key}
					placement="right"
					width={'70vw'}
					onClose={() => {
						resetAction()
					}}
					onOK={() => {
						performAction(action)
					}}
					open={action && (action === actions.ALARM_DOC_ACTION_CONTENT_RECOMMENDED || action === actions.ALARM_DOC_ACTION_HSP_RECOMMENDED)}
					text={{
						title: `${lang('intervention')} ${lang('for')} ${patientPseudoName}`,
						cancel: lang('cancel'),
						ok: lang('ok')
					}}>
					{actionElement}
				</Drawer>
				<div className="exo-task-symptom-alarms">
					<List data={symptoms} pagination={null} />
				</div>
				<div className="exo-task-symptom-alarm-interventions">{renderInterventions(data)}</div>
			</div>
		</div>
	)
}
